import type { ReactNode } from "react";

import { StyledSignalFiltersWrapper } from "./styles";

type Props = {
    className?: string;
    children: ReactNode;
};

const SignalFiltersWrapper = (props: Props) => {
    return (
        <StyledSignalFiltersWrapper
            className={props.className}
            data-automation="signal-filters-wrapper"
        >
            {props.children}
        </StyledSignalFiltersWrapper>
    );
};

export default SignalFiltersWrapper;
